import * as signalR from "@microsoft/signalr";
 
import log from "./logging";
import { authProvider } from "./auth/AuthProvider";
import store from "../store/store"
import * as dom from "../store/models/domain"
import {addPendingUpdates} from "../store/reducers/domain/facilities";

var connection: signalR.HubConnection | undefined = undefined;

const connectUpdateWatcher = () => {
    if(connection) {
        ensureConnected();
        return Promise.resolve();
    }

    connection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_API_URI}/hubs/updates`, 
            { 
                accessTokenFactory: async () => (await authProvider.getAccessToken()) ?? ""
            })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Error)
        .build();

    connection.on("PendingUpdatesNotification", async function (notification: dom.PendingUpdatesNotification) {
       
        try{
            if(!notification.facilityId || notification.facilityId === authProvider.getAccountInfo()?.facility?.id) {
                store.dispatch(addPendingUpdates(notification));
            }
        }
        catch(e){
            log.error('Error updating PendingUpdatesNotification', e);
        }   
    });      

    connection.onclose(function (err) {
        
    });
    
    connection.start().then(function () {        
        log.info('Global UpdatesHub connected.');
        return Promise.resolve();     
    }).catch(function (err) {                
        log.error('Failed to connect to Global UpdatesHub', err);
        return Promise.resolve();
    })
}

const stopUpdateWatcher = (): void => {    
    if(connection) {
        const cnc = connection;
        connection = undefined;
        cnc.stop().then(function () {
            log.info('UpdatesHub disconnected.')
        }).catch(function (err) {            
            log.error('Failed to disconnect  UpdatesHub', err);
        });     
    }       
}

const ensureConnected = () => {
    if(connection && connection.state === signalR.HubConnectionState.Disconnected) {
        connection.start()
        .then(function () {        
            log.info('Global UpdatesHub connected.');        
        })
        .catch(function (err) {log.error('Failed to start connection to Global UpdatesHub', err);});
    }
}

const getConnection = (): signalR.HubConnection | undefined => connection;

const asyncTaskWatcher = {connectUpdateWatcher, stopUpdateWatcher, ensureConnected, getConnection};

export default asyncTaskWatcher;

